import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimaryButtonComponent } from '../components/primary-button/primary-button.component';
@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [PrimaryButtonComponent],
  // providers: [MySharedService],
  exports: [PrimaryButtonComponent,],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SharedModule { }
